export interface ApiConfig {
  timeout: number;
  url: string;
  disableRedirectOnUnauthorized: boolean;
  token: string;
}

export interface ApiOptions {
  token?: string;
  url?: string;
  disableRedirectOnUnauthorized?: boolean;
  timeout?: number;
}

export enum ContentType {
  JSON = 'application/json',
  FORM = 'application/x-www-form-urlencoded',
  MULTIPART = 'multipart/form-data',
}

export interface ApiHeaders {
  authorization?: string;
  contentType?: ContentType;
}
